import { SET_MODAL_SEEN } from '../actions'

const initialState = {}

export default (state = initialState, action) => {
    switch (action.type) {
    case SET_MODAL_SEEN:
        const existingModalData = state[action.payload.customerId] ? state[action.payload.customerId] : {}
        if (existingModalData[action.payload.modalId]) {
            // If the record exists, increase the seen qty
            const record = existingModalData[action.payload.modalId]
            existingModalData[action.payload.modalId] = {
                seenQty: (record.seenQty + 1)
            }
        } else {
            // If the record doesn't exist, add the first seen qty count
            existingModalData[action.payload.modalId] = {
                seenQty: 1
            }
        }

        return {
            ...state,
            [action.payload.customerId]: existingModalData
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./resources/js/redux/reducers/modalReducer.js